import { render, staticRenderFns } from "./ResetIndex.vue?vue&type=template&id=02ca0ac1&"
import script from "./ResetIndex.vue?vue&type=script&lang=js&"
export * from "./ResetIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports